// H2.8 — sesión v2: guarda el ACCESS token (30 min) y los datos de sesión.
// El refresh token NO vive aquí: va en cookie httpOnly que maneja el backend
// (diseño R1 — un XSS no puede robar la sesión persistente).
const KEY = 'app_session';

function decodeJwt(token) {
  try {
    const [, payload] = token.split('.');
    return JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
  } catch {
    return null;
  }
}

export const authStore = {
  /** Guarda la respuesta `authenticated` del login/refresh v2. */
  setSession({ access_token, usuario, tenant }) {
    sessionStorage.setItem(
      KEY,
      JSON.stringify({ token: access_token, usuario, tenant })
    );
  },
  _raw() {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  },
  /** Access token aunque esté vencido (el interceptor lo refresca solo). */
  getToken() {
    return this._raw()?.token || null;
  },
  /** true si el access token existe y aún no vence. */
  hasFreshToken() {
    const t = this.getToken();
    if (!t) return false;
    const claims = decodeJwt(t);
    return Boolean(claims?.exp && claims.exp * 1000 > Date.now());
  },
  getClaims() {
    const t = this.getToken();
    return t ? decodeJwt(t) : null;
  },
  getUsuario() {
    return this._raw()?.usuario || null;
  },
  getTenant() {
    return this._raw()?.tenant || null;
  },
  getName() {
    return this.getUsuario()?.name || null;
  },
  /** rol en el proyecto activo (viene del claim del token). */
  getTipo() {
    return this.getClaims()?.rol || null;
  },
  /** permiso de telecontrol en el proyecto activo. */
  getTelecontrol() {
    return Boolean(this.getClaims()?.tele);
  },
  clear() {
    sessionStorage.removeItem(KEY);
  },
};
